/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const StyledButton = styled.a`
  
`;

export { StyledButton };
